import { createSelector, createSlice } from "@reduxjs/toolkit";
import { t } from "i18next";
import { produce } from "immer";

import { RequirementToast, successAddToast } from "@components/common/Toast";

const initialState = {
    workflowData: [],
    nextPreviousStep: "next",
};

export const workFlowDataSlice = createSlice({
    name: "workFlowDataSlice",
    initialState,
    reducers: {
        setWorkflowData: (state, action) => {
            state.workflowData = action.payload;
        },
        removeLastWorkflow: (state, { payload }) => {
            state.workflowData = produce(state.workflowData, (draftState) => {
                if (draftState.length > 0) {
                    draftState.splice(draftState.length - 1, 1);

                    if (
                        !payload.isModif ||
                        (payload.isModif && payload.isCancelEditProduct)
                    ) {
                        draftState[draftState.length - 1].workflow[
                            draftState[draftState.length - 1].index
                        ].NbrOfChoices =
                            draftState[draftState.length - 1].workflow[
                                draftState[draftState.length - 1].index
                            ].NbrOfChoices - 1;

                        if (
                            draftState[draftState.length - 1].workflow[
                                draftState[draftState.length - 1].index
                            ].NbrOfChoices === 0
                        ) {
                            draftState[draftState.length - 1].workflow[
                                draftState[draftState.length - 1].index
                            ].selectedChoicesWithspecialPrice = 0;
                            draftState[draftState.length - 1].workflow[
                                draftState[draftState.length - 1].index
                            ].selectedChoicesWithStepPrice = 0;
                        } else if (
                            draftState[draftState.length - 1].workflow[
                                draftState[draftState.length - 1].index
                            ].NbrOfChoices >
                            draftState[draftState.length - 1].workflow[
                                draftState[draftState.length - 1].index
                            ].nbrOfChoicesWithspecialPrice
                        ) {
                            if (
                                draftState[draftState.length - 1].workflow[
                                    draftState[draftState.length - 1].index
                                ].selectedChoicesWithStepPrice > 0
                            )
                                draftState[draftState.length - 1].workflow[
                                    draftState[draftState.length - 1].index
                                ].selectedChoicesWithStepPrice =
                                    draftState[draftState.length - 1].workflow[
                                        draftState[draftState.length - 1].index
                                    ].selectedChoicesWithStepPrice - 1;
                        } else {
                            draftState[draftState.length - 1].workflow[
                                draftState[draftState.length - 1].index
                            ].selectedChoicesWithspecialPrice =
                                draftState[draftState.length - 1].workflow[
                                    draftState[draftState.length - 1].index
                                ].selectedChoicesWithspecialPrice - 1;
                        }
                    }
                }
            });
        },
        //@typescript-eslint/no-unused-vars
        setNextWorkflowStep: (state) => {
            state.workflowData[state.workflowData.length - 1].index += 1;
            state.nextPreviousStep = "next";
        },
        setPreviousWorkflowStep: (state) => {
            state.workflowData[state.workflowData.length - 1].index -= 1;
            state.nextPreviousStep = "prev";
        },
        steWorkflowStepIndex: (state, { payload }) => {
            state.workflowData[state.workflowData.length - 1].index = payload;
            state.nextPreviousStep = "next";
        },
        steWorkflowStep: (state, { payload }) => {
            state.workflowData[state.workflowData.length - 1].index = payload;
        },
        toggleBasicCompositionitem: (state, { payload }) => {
            state.workflowData[state.workflowData.length - 1].workflow[
                state.workflowData[state.workflowData.length - 1].index
            ].Items[payload].basicCompositionActive =
                !state.workflowData[state.workflowData.length - 1].workflow[
                    state.workflowData[state.workflowData.length - 1].index
                ].Items[payload].basicCompositionActive;
            if (
                !state.workflowData[state.workflowData.length - 1].workflow[
                    state.workflowData[state.workflowData.length - 1].index
                ].Items[payload].basicCompositionActive
            ) {
                RequirementToast(t("Deleted product"));
            } else {
                successAddToast(t("Product added"));
            }
        },
        addWorkflowStepChoice: (state, { payload }) => {
            const {
                NbrOfChoices,
                selectedChoicesWithStepPrice,
                selectedChoicesWithspecialPrice,
                haveWorkflow,
                menuOnModification,
                isAutoPermutation,
            } = payload;
            state.workflowData[state.workflowData.length - 1].workflow[
                state.workflowData[state.workflowData.length - 1].index
            ].NbrOfChoices = NbrOfChoices;
            state.workflowData[state.workflowData.length - 1].workflow[
                state.workflowData[state.workflowData.length - 1].index
            ].selectedChoicesWithStepPrice = selectedChoicesWithStepPrice;
            state.workflowData[state.workflowData.length - 1].workflow[
                state.workflowData[state.workflowData.length - 1].index
            ].selectedChoicesWithspecialPrice = selectedChoicesWithspecialPrice;

            if (
                state.workflowData[state.workflowData.length - 1].index <
                    state.workflowData[state.workflowData.length - 1].step &&
                state.workflowData[state.workflowData.length - 1].workflow[
                    state.workflowData[state.workflowData.length - 1].index
                ].maxNbrOfChoices === NbrOfChoices &&
                !haveWorkflow &&
                state.workflowData[state.workflowData.length - 1].workflow[
                    state.workflowData[state.workflowData.length - 1].index
                ].haveComment === false &&
                !menuOnModification
            ) {
                state.workflowData[state.workflowData.length - 1].index += 1;
                state.nextPreviousStep = "next";
            }

            !haveWorkflow &&
                state.workflowData[state.workflowData.length - 1].index <
                    state.workflowData[state.workflowData.length - 1].step &&
                !isAutoPermutation &&
                successAddToast(t("Product added"));
        },
        minusNbrChoiceOfCurrentStep: (state) => {
            state.workflowData[state.workflowData.length - 1].workflow[
                state.workflowData[state.workflowData.length - 1].index
            ].NbrOfChoices -= 1;

            const {
                selectedChoicesWithspecialPrice,
                selectedChoicesWithStepPrice,
            } = JSON.parse(localStorage.getItem("stepDetails")) || {
                selectedChoicesWithspecialPrice: 0,
                selectedChoicesWithStepPrice: 0,
            };
            state.workflowData[state.workflowData.length - 1].workflow[
                state.workflowData[state.workflowData.length - 1].index
            ].selectedChoicesWithStepPrice = selectedChoicesWithStepPrice;

            state.workflowData[state.workflowData.length - 1].workflow[
                state.workflowData[state.workflowData.length - 1].index
            ].selectedChoicesWithspecialPrice = selectedChoicesWithspecialPrice;
            RequirementToast(t("Deleted product"));
        },
        goToPreviousWorkflow: (state) => {
            state.workflowData = produce(state.workflowData, (draftState) => {
                if (draftState.length > 0) {
                    draftState.splice(draftState.length - 1, 1);
                    if (
                        draftState[draftState.length - 1].step >
                            draftState[draftState.length - 1].index &&
                        !draftState[draftState.length - 1].workflow[
                            draftState[draftState.length - 1].index
                        ].haveComment &&
                        draftState[draftState.length - 1].workflow[
                            draftState[draftState.length - 1].index
                        ].NbrOfChoices ===
                            draftState[draftState.length - 1].workflow[
                                draftState[draftState.length - 1].index
                            ].maxNbrOfChoices
                    ) {
                        draftState[draftState.length - 1].index += 1;
                    }
                }
            });
        },
        resetNbrOfChoice: (state) => {
            state.workflowData[state.workflowData.length - 1].workflow[
                state.workflowData[state.workflowData.length - 1].index
            ].NbrOfChoices = 0;
        },
        intializeItemSelectedBasicComp: (state, { payload }) => {
            if (!payload.product.haveBasicComposition) return;
            const items = state.workflowData[
                state.workflowData.length - 1
            ].workflow[
                state.workflowData[state.workflowData.length - 1].index
            ].Items.map((item) =>
                item.iuud === payload.product.iuud
                    ? { ...item, selectedBasicComposition: [] }
                    : { ...item }
            );

            state.workflowData[state.workflowData.length - 1].workflow[
                state.workflowData[state.workflowData.length - 1].index
            ].Items = items;
        },
        setSteptag: (state, { payload }) => {
            state.workflowData[state.workflowData.length - 1].workflow[
                state.workflowData[state.workflowData.length - 1].index
            ].stepTags = payload;
        },
    },
});

const getStepTags = (state) => {
    const last = state.workFlowDataSlice.workflowData.at(-1);
    if (!last) return [];

    const step = last.workflow?.[last.index];

    if (!step?.stepTags) return [];

    const stepTagsData = step?.stepTags ?? [];

    const stepTags =
        typeof stepTagsData[0] === "string"
            ? state.orderSlice.tags.filter(
                  (tag) => stepTagsData.includes(tag.id) && tag.isVisible
              )
            : stepTagsData.filter((tag) => tag.isVisible);
    return stepTags;
};

const getActiveStepTags = (state) => {
    const last = state.workFlowDataSlice.workflowData.at(-1);
    if (!last) return [];

    const step = last.workflow?.[last.index];

    if (!step?.stepTags) return [];

    const stepTagsData = step.stepTags ?? [];

    return stepTagsData.filter((tag) => tag.active);
};

export const memoizedGetStepTags = createSelector(
    [getStepTags],
    (stepTags) => stepTags
);

export const memoizedGetActiveStepTags = createSelector(
    [getActiveStepTags],
    (activeStepTags) => activeStepTags
);

export const {
    setWorkflowData,
    setNextWorkflowStep,
    setPreviousWorkflowStep,
    steWorkflowStepIndex,
    toggleBasicCompositionitem,
    addWorkflowStepChoice,
    removeLastWorkflow,
    minusNbrChoiceOfCurrentStep,
    goToPreviousWorkflow,
    resetNbrOfChoice,
    intializeItemSelectedBasicComp,
    setSteptag,
} = workFlowDataSlice.actions;

export default workFlowDataSlice.reducer;
